/* beautiful-react-hooks version: 0.30.6 */
var isApiSupported = function isApiSupported(api) {
  return api in window;
};

export default isApiSupported;
